import { number, shape, string } from "prop-types";

export default {
  id: number.isRequired,
  fname: string,
  lname: string,
  profilePictureUrl: string,
  title: string,
  locale: string,
  company: shape({
    id: number,
    name: string,
  }).isRequired,
  roleInCompany: string,
};
